import { handleActions } from 'redux-actions';
import * as filtersActions from '../actions/filters';

let initState = {
  count: 0,
  fields: null,
  search: null,
  typeList: null,
};

export const filters = handleActions(
  {
    [filtersActions.updateFilterFieldsOrdersForDocuments]: (state, action) => {
      return {
        ...state,
        fields: action.payload,
      };
    },
    [filtersActions.searchOrdersForDocuments]: (state, action) => {
      return {
        ...state,
        search: action.payload,
      };
    },
    [filtersActions.changeTypeListDocuments]: (state, action) => {
      return {
        ...state,
        typeList: action.payload,
      };
    },
    [filtersActions.countFiltersOrdersForDocuments]: (state, action) => {
      return {
        ...state,
        count: action.payload,
      };
    },
    [filtersActions.resetFiltersOrdersForDocuments]: (state, action) => {
      return {
        ...state,
        fields: null,
        search: null,
        count: 0,
      };
    },
  },
  initState
);
